import { Component, Input, OnInit } from '@angular/core';
import { faInfo, faClock, faMoneyBill, faUniversalAccess, faSwimmer, faCalendarAlt, faBell, faArrowRight, faStream } from '@fortawesome/free-solid-svg-icons';
import { first } from 'rxjs/operators';
import { VssOrganizationsService } from '../vss-organizations.service';

@Component({
    selector: 'app-vss-organization-menu',
    templateUrl: './vss-organization-menu.component.html',
    styleUrls: ['./vss-organization-menu.component.css'],
    standalone: false
})
export class VssOrganizationMenuComponent implements OnInit {

  @Input() id: any;
  public organizationType: number;
  public icons: { [name: string]: any } = {
    'faInfo': faInfo,
    'faClock': faClock,
    'faMoneyBill': faMoneyBill,
    'faUniversalAccess': faUniversalAccess,
    'faSwimmer': faSwimmer,
    'faCalendarAlt': faCalendarAlt,
    'faBell': faBell,
    'faArrowRight': faArrowRight,
    'faStream': faStream
  };

  constructor(private _vssOrganizationsService: VssOrganizationsService) { }

  ngOnInit(): void {
    // tslint:disable-next-line:radix
    this.organizationType = parseInt(localStorage.getItem('orgId'));
    if (!this.organizationType) {
      this._vssOrganizationsService.vssOrganizationTypeSubject.pipe(first()).subscribe(result => {
        this.organizationType = result;
      });
    }
  }
}
